import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";

import { objectKeysToCamelCase } from "../../utils/string";

/**
 * Componente genérico para fazer requisições GET e renderizar componentes que dependam do resultado.
 */
function Fetch({ url, children }) {
  const [data, setData] = useState(null);
  useEffect(
    () => {
      const source = axios.CancelToken.source();
      axios.get(url, { canceltoken: source.token }).then(resp => setData(objectKeysToCamelCase(resp.data)));
      return () => source.cancel();
    },
    [url]
  );
  return <>{children(data)}</>;
}

Fetch.propTypes = {
  /** Função que aceita o resultado do GET e renderiza os descendentes */
  children: PropTypes.func.isRequired,
  /** URL para onde a requisição será enviada */
  url: PropTypes.string.isRequired,
};

export default Fetch;
